// Serviço para buscar dados da API Nuvemshop
// Prioriza config.js (para produção Hostgator) sobre variáveis de ambiente
const getApiUrl = () => {
  if (window.EMATECH_CONFIG?.API_URL) {
    return window.EMATECH_CONFIG.API_URL;
  }
  // Fallback para desenvolvimento local
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  // URL padrão do Railway em produção
  return 'https://ematech-production.up.railway.app';
};

const API_URL = getApiUrl();

export const nuvemshopService = {
  // Buscar todos os produtos
  async getProducts() {
    try {
      const response = await fetch(`${API_URL}/api/nuvemshop/products`);
      const data = await response.json();
      
      if (data.success && data.products) {
        // Transformar dados da Nuvemshop para o formato do frontend
        return data.products.map(product => {
          const variant = product.variants?.[0] || {};
          const image = product.images?.[0]?.src || '/products/placeholder.webp';
          const name = typeof product.name === 'object' ? product.name.pt : product.name;
          const description = typeof product.description === 'object' 
            ? (product.description.pt || '').replace(/<[^>]*>/g, '') 
            : (product.description || '').replace(/<[^>]*>/g, '');
          
          const price = parseFloat(variant.price) || 0;
          const comparePrice = parseFloat(variant.compare_at_price) || price;
          const discount = comparePrice > price ? Math.round((1 - price / comparePrice) * 100) : 0;

          return {
            id: product.id,
            variantId: variant.id,
            name: name,
            description: description || 'Resina epóxi de alta qualidade.',
            price: price,
            originalPrice: comparePrice,
            discount: discount,
            image: image,
            weight: extractWeight(name),
            category: 'Resinas',
            checkoutUrl: product.canonical_url || `https://ematech6.lojavirtualnuvem.com.br/produtos/${product.handle?.pt || product.id}/`,
            inStock: product.has_stock !== false
          };
        });
      }
      return [];
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
      return [];
    }
  },

  // Buscar categorias
  async getCategories() {
    try {
      const response = await fetch(`${API_URL}/api/nuvemshop/categories`);
      const data = await response.json();
      
      if (data.success && data.categories) {
        return data.categories.map(cat => ({
          id: cat.id,
          name: typeof cat.name === 'object' ? cat.name.pt : cat.name
        }));
      }
      return [];
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
      return [];
    }
  },

  // Gerar URL de checkout
  async getCheckoutUrl(items) {
    try {
      const response = await fetch(`${API_URL}/api/nuvemshop/checkout/url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      
      if (data.success && data.checkout_url) {
        return data.checkout_url;
      }
      return null;
    } catch (error) {
      console.error('Erro ao gerar checkout:', error);
      return null;
    }
  }
};

// Função auxiliar para extrair peso do nome
function extractWeight(name) {
  const match = name?.match(/(\d+[,.]?\d*)\s*(kg|g)/i);
  if (match) {
    return `${match[1]} ${match[2]}`;
  }
  return '';
}

export default nuvemshopService;
